import React, { FunctionComponent } from 'react'
import { useTranslation } from '../../utils/convergence'
import { QRCode } from '..'
import { Logo } from '@afterpaytouch/core'
import styles from './styles.module.css'

interface Props {
  src?: string
}

export const QRCodeCashAppPay: FunctionComponent<Props> = ({ src = '' }) => {
  const isQRCodeSrcExists = src.length > 0
  const { t } = useTranslation()

  if (!isQRCodeSrcExists) {
    return null
  }

  return (
    <div className={styles.component}>
      <div className={styles.imgContainer}>
        <QRCode src={src} alt={t('cashAuth:qrCodeAlt')} />
        <Logo name='Afterpay' title={t('common:brandName')} description={t('common:brandName')} size={'Medium'} />
      </div>
    </div>
  )
}
